"use client";

import React, { Suspense, useState } from "react";
import classNames from "classnames";
import { Sidebar } from "@/components/Layout";
import { Header } from "@/components/Header";
import { useModalController } from "@/components/molecules/Modal";
import { NewPageModal } from "@/components/organisms/NewPageModal/NewPageModal";
import { CreateAIPageModal } from "@/components/organisms/CreateAIPageModal/CreateAIPageModal";
import { RequireAuth } from "@/modules/auth/RequireAuth";
import { ConsumerProfileOverlayProvider } from "@/modules/consumerProfile/context/ConsumerProfileOverlayContext";

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
    const newPageModalController = useModalController();
    const aiPageModalController = useModalController();
    return (
        <RequireAuth>
            <div className="flex min-h-screen bg-dashboard-bg" data-pdf-layout>
                <Suspense fallback={<div className="w-[76px] bg-menu-background"></div>}>
                    <div data-pdf-hide>
                    <Sidebar
                        isCollapsed={isSidebarCollapsed}
                        onToggle={(value) => (value != undefined ? setIsSidebarCollapsed(value) : setIsSidebarCollapsed((prev) => !prev))}
                        handleNewPage={() => newPageModalController.open()}
                    />
                    </div>
                </Suspense>
                <div className="flex-1 flex flex-col items-center relative min-w-0 overflow-x-clip">
                    <div
                        className="fixed inset-0 pointer-events-none opacity-30"
                        style={{
                            backgroundImage: `url('/images/l2t_logo_bg.png')`,
                            backgroundPosition: "right bottom",
                            backgroundSize: "500px auto",
                            backgroundRepeat: "no-repeat",
                        }}
                    />
                    <div className="relative flex-1 h-auto w-full flex flex-col items-center">
                        <div className={classNames("w-full sticky top-0 z-60")} data-pdf-hide>
                            <Header showMenuButton={false} />
                        </div>
                        <div className="flex-1 h-auto w-full relative">
                            <ConsumerProfileOverlayProvider>
                                {children}
                            </ConsumerProfileOverlayProvider>
                        </div>
                    </div>
                </div>
                <NewPageModal controller={newPageModalController} />
            </div>
        </RequireAuth>
    );
}
